import "./PrivacyStyle.css";
import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      {/* Hero Section */}
      <section className="privacy-hero text-white py-5 py-md-6">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 mx-auto text-center">
              <div className="hero-content">
                <h1 className="display-4 mb-3">Privacy Policy</h1>
                <p className="lead mb-4">
                  Your privacy is important to us. This policy explains how we
                  collect, use, and protect your personal information.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,160C672,160,768,192,864,192C960,192,1056,160,1152,154.7C1248,150,1344,170,1392,180.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* Main Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white border-bottom">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="h5 mb-0 text-dark">
                    <i className="fa fa-info-circle mr-2 text-primary"></i>
                    &nbsp;Detailed Privacy Information
                  </h2>
                  <span className="badge bg-primary text-white">v2.1</span>
                </div>
              </div>

              <div className="card-body">
                <nav aria-label="Privacy policy sections" className="mb-4">
                  <div
                    className="nav nav-pills flex-column flex-sm-row"
                    id="privacy-policy-tabs"
                    role="tablist"
                  >
                    <button
                      className="flex-sm-fill text-sm-center nav-link active"
                      id="overview-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#overview"
                      type="button"
                      role="tab"
                    >
                      <i className="fa fa-eye mr-2"></i>&nbsp;Overview
                    </button>
                    <button
                      className="flex-sm-fill text-sm-center nav-link"
                      id="data-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#data"
                      type="button"
                      role="tab"
                    >
                      <i className="fa fa-database mr-2"></i>&nbsp; Data
                      Collection
                    </button>
                    <button
                      className="flex-sm-fill text-sm-center nav-link"
                      id="use-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#use"
                      type="button"
                      role="tab"
                    >
                      <i className="fa fa-cogs mr-2"></i>Data Use
                    </button>
                    <button
                      className="flex-sm-fill text-sm-center nav-link"
                      id="rights-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#rights"
                      type="button"
                      role="tab"
                    >
                      <i className="fa fa-shield mr-2"></i>Your Rights
                    </button>
                  </div>
                </nav>

                <div className="tab-content" id="privacy-policy-content">
                  {/* Overview Section */}
                  <div
                    className="tab-pane fade show active"
                    id="overview"
                    role="tabpanel"
                  >
                    <h3 className="h5 mb-3 text-primary">
                      <i className="fa fa-home mr-2"></i>&nbsp;Overview
                    </h3>
                    <p>
                      We are committed to protecting your privacy and ensuring
                      the security of your personal information. This Privacy
                      Policy outlines our practices regarding data collection,
                      use, and disclosure.
                    </p>
                    <div className="alert alert-light border">
                      <i className="fa fa-lightbulb-o mr-2 text-warning"></i>
                      &nbsp;
                      <strong>Key Point:</strong> We never sell your personal
                      information to third parties.
                    </div>
                    <h4 className="h6 mt-4">Our Commitment</h4>
                    <ul className="fa-ul">
                      <li>
                        <i className="fa fa-li fa-check text-success"></i>
                        Transparent data practices
                      </li>
                      <li>
                        <i className="fa fa-li fa-check text-success"></i>Secure
                        storage of your information
                      </li>
                      <li>
                        <i className="fa fa-li fa-check text-success"></i>
                        Respect for your privacy choices
                      </li>
                    </ul>
                  </div>

                  {/* Data Collection Section */}
                  <div className="tab-pane fade" id="data" role="tabpanel">
                    <h3 className="h5 mb-3 text-primary">
                      <i className="fa fa-database mr-2"></i>&nbsp;Information
                      We Collect
                    </h3>
                    <p>
                      We collect several types of information from and about
                      users of our website, including:
                    </p>

                    <div className="row mt-4">
                      <div className="col-md-6 mb-4">
                        <div className="card h-100 border-0 shadow-sm">
                          <div className="card-header bg-light">
                            <h4 className="h6 mb-0">
                              <i className="fa fa-user-circle-o mr-2 text-primary"></i>
                              &nbsp;Personal Information
                            </h4>
                          </div>
                          <div className="card-body">
                            <ul className="fa-ul">
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Name and contact details
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Email address
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Account credentials
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Payment information (if applicable)
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Demographic information
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="card h-100 border-0 shadow-sm">
                          <div className="card-header bg-light">
                            <h4 className="h6 mb-0">
                              <i className="fa fa-line-chart mr-2 text-primary"></i>
                              &nbsp;Usage Data
                            </h4>
                          </div>
                          <div className="card-body">
                            <ul className="fa-ul">
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                IP addresses
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Browser type and version
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Pages visited and time spent
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Device information
                              </li>
                              <li>
                                <i className="fa fa-li fa-check-circle text-success"></i>
                                Location data (general)
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h4 className="h6 mt-2">
                      <i className="fa fa-cookie-bite mr-2"></i>
                      Cookies and Tracking Technologies
                    </h4>
                    <div className="card border-0 bg-light">
                      <div className="card-body">
                        <p>
                          We use cookies and similar tracking technologies to
                          track activity on our website and hold certain
                          information. You can instruct your browser to refuse
                          all cookies or to indicate when a cookie is being
                          sent.
                        </p>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <h5 className="h6">Essential Cookies</h5>
                            <p className="small">
                              Required for site functionality
                            </p>
                          </div>
                          <div className="col-md-6">
                            <h5 className="h6">Analytics Cookies</h5>
                            <p className="small">
                              Help us improve our services
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Data Use Section */}
                  <div className="tab-pane fade" id="use" role="tabpanel">
                    <h3 className="h5 mb-3 text-primary">
                      <i className="fa fa-cogs mr-2"></i>&nbsp;How We Use Your
                      Information
                    </h3>
                    <p>
                      We use the information we collect for various purposes:
                    </p>

                    <div className="table-responsive mt-4">
                      <table className="table table-bordered">
                        <thead className="thead-light">
                          <tr>
                            <th width="30%">
                              <i className="fa fa-tasks mr-2"></i>&nbsp;Purpose
                            </th>
                            <th>
                              <i className="fa fa-info-circle mr-2"></i>
                              &nbsp;Description
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Service Provision</td>
                            <td>
                              To provide and maintain our service, authenticate
                              users, and process transactions
                            </td>
                          </tr>
                          <tr>
                            <td>Improvements</td>
                            <td>
                              To improve and personalize user experience,
                              develop new features
                            </td>
                          </tr>
                          <tr>
                            <td>Communication</td>
                            <td>
                              To contact you with updates, newsletters, and
                              promotional offers (with consent)
                            </td>
                          </tr>
                          <tr>
                            <td>Security</td>
                            <td>
                              To monitor usage, detect and prevent fraud, and
                              protect our systems
                            </td>
                          </tr>
                          <tr>
                            <td>Analytics</td>
                            <td>
                              To analyze trends, track user movements, and
                              gather demographic information
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="callout callout-warning bg-light-warning p-4 mt-4 border-start border-warning border-3">
                      <h4 className="h6">
                        <i className="fa fa-exclamation-triangle mr-2"></i>
                        &nbsp;Data Sharing and Disclosure
                      </h4>
                      <p className="mb-0">
                        We only share data with trusted third-party service
                        providers who assist us in operating our website,
                        conducting our business, or serving our users, so long
                        as those parties agree to keep this information
                        confidential. We may also release information when
                        appropriate to comply with the law or protect our
                        rights.
                      </p>
                    </div>
                  </div>

                  {/* Your Rights Section */}
                  <div className="tab-pane fade" id="rights" role="tabpanel">
                    <h3 className="h5 mb-3 text-primary">
                      <i className="fa fa-shield mr-2"></i>&nbsp; Your Data
                      Protection Rights
                    </h3>
                    <p>
                      Depending on your location, you may have the following
                      rights regarding your personal data:
                    </p>

                    <div className="list-group mb-4 mt-4">
                      <div className="list-group-item">
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1">
                            <i className="fa fa-search mr-2 text-primary"></i>
                            &nbsp;Right to Access
                          </h5>
                          <span className="badge bg-primary rounded-pill">
                            &nbsp;GDPR, CCPA
                          </span>
                        </div>
                        <p className="mb-1">
                          Request copies of your personal data that we hold
                        </p>
                      </div>
                      <div className="list-group-item">
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1">
                            <i className="fa fa-edit mr-2 text-primary"></i>
                            &nbsp;Right to Rectification
                          </h5>
                          <span className="badge bg-primary rounded-pill">
                            GDPR
                          </span>
                        </div>
                        <p className="mb-1">
                          Request correction of any inaccurate or incomplete
                          data
                        </p>
                      </div>
                      <div className="list-group-item">
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1">
                            <i className="fa fa-trash-o mr-2 text-primary"></i>
                            &nbsp;Right to Erasure
                          </h5>
                          <span className="badge bg-primary rounded-pill">
                            GDPR
                          </span>
                        </div>
                        <p className="mb-1">
                          Request deletion of your personal data under certain
                          conditions
                        </p>
                      </div>
                      <div className="list-group-item">
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1">
                            <i className="fa fa-ban mr-2 text-primary"></i>
                            &nbsp;Right to Restrict Processing
                          </h5>
                          <span className="badge bg-primary rounded-pill">
                            GDPR
                          </span>
                        </div>
                        <p className="mb-1">
                          Request restriction of processing your personal data
                        </p>
                      </div>
                      <div className="list-group-item">
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1">
                            <i className="fa fa-file mr-2 text-primary"></i>{" "}
                            &nbsp;Right to Data Portability
                          </h5>
                          <span className="badge bg-primary rounded-pill">
                            GDPR
                          </span>
                        </div>
                        <p className="mb-1">
                          Request transfer of your data to another organization
                        </p>
                      </div>
                      <div className="list-group-item">
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1">
                            <i className="fa fa-times-circle mr-2 text-primary"></i>
                            &nbsp;Right to Object
                          </h5>
                          <span className="badge bg-primary rounded-pill">
                            GDPR
                          </span>
                        </div>
                        <p className="mb-1">
                          Object to our processing of your personal data
                        </p>
                      </div>
                    </div>

                    <div className="card border-primary mt-4">
                      <div className="card-header bg-primary text-white">
                        <i className="fa fa-question-circle mr-2"></i> &nbsp;How
                        to Exercise Your Rights
                      </div>
                      <div className="card-body">
                        <p>
                          To exercise any of these rights, please contact us
                          using one of these methods:
                        </p>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="d-flex align-items-start mb-3">
                              <i className="fa fa-envelope mt-1 mr-3 text-primary"></i>
                              &nbsp;
                              <div>
                                <h5 className="h6 mb-1">Email</h5>
                                <Link
                                  to="mailto:osman.techy@gmail.com"
                                  className="text-primary"
                                >
                                  Send me an email
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="d-flex align-items-start mb-3">
                              <i className="fa fa-phone mt-1 mr-3 text-primary"></i>
                              &nbsp;
                              <div>
                                <h5 className="h6 mb-1">Phone</h5>
                                <Link
                                  to="tel:+16518000000"
                                  className="text-primary"
                                >
                                  (651) 800-0000
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-3">
                          <h5 className="h6">What We'll Need</h5>
                          <p className="small mb-0">
                            To protect your information, we may need to verify
                            your identity before processing your request. Please
                            be prepared to provide identifying information.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer bg-light">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                  <small className="text-muted">
                    <i className="fa fa-clock-o mr-1"></i>&nbsp;This policy is
                    effective as of {new Date().toLocaleDateString()}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
